import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=51fd0d94&scoped=true&"
import script from "./index copy.vue?vue&type=script&lang=js&"
export * from "./index copy.vue?vue&type=script&lang=js&"
import style0 from "./index copy.vue?vue&type=style&index=0&id=51fd0d94&lang=scss&scoped=true&"
import style1 from "./index copy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd0d94",
  null
  
)

export default component.exports